var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseMinusOutlinedFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C5.5888 2 2 5.5888 2 10C2 14.4112 5.5888 18 10 18C14.4112 18 18 14.4112 18 10C18 5.5888 14.4112 2 10 2ZM10 3.6C13.5288 3.6 16.4 6.4712 16.4 10C16.4 13.5288 13.5288 16.4 10 16.4C6.4712 16.4 3.6 13.5288 3.6 10C3.6 6.4712 6.4712 3.6 10 3.6ZM7.6 9.2C7.15817 9.2 6.8 9.55817 6.8 10C6.8 10.4418 7.15817 10.8 7.6 10.8H12.4C12.8418 10.8 13.2 10.4418 13.2 10C13.2 9.55817 12.8418 9.2 12.4 9.2H7.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseMinusOutlinedFigma);
export default __webpack_public_path__ + "static/media/collapse-minus-outlined-figma.62497a7a3bb3a2a669ed6fdfb391d5a3.svg";
export { ForwardRef as ReactComponent };